<script>
  import ByPersonTrendChart from './ByPersonTrendChart.vue';

  export default {
    name: 'HaeOpportunityTrends',
    extends: ByPersonTrendChart,
    data() {
      return {
        chartId: 'opportunityTrends',
        propertyName: 'number_ha_appointments',
        propertyNamePerson: 'ha_opportunities',
        label: 'HAE Appts',
        curYearColor: '#998CE3',
        prevYearColor: '#6AEDC7',
        labelFormat: ',.0f',
      };
    },
  };
</script>
